// Must be kept in sync with UserInfo in lib.user_info.go
export class UserInfo {
    displayName: string;
    email: string;
    username: string;
    avatarUrl: string;

    private constructor(displayName: string, email: string, username: string, avatarUrl: string) {
        this.displayName = displayName;
        this.email = email;
        this.username = username;
        this.avatarUrl = avatarUrl;
    }

    public static fromRaw(rawData: any): UserInfo {
        return new UserInfo(
            rawData.DisplayName,
            rawData.Email,
            rawData.Username,
            rawData.AvatarUrl,
        )
    }
    public static empty(): UserInfo {
        return new UserInfo(
            null,
            null,
            null,
            null,
        )
    }
}
